var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('app-navbar',{attrs:{"showToggle":""},on:{"toggleDrawer":_vm.toggleDrawer}}),_c('app-drawer',{model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }